export const TeamUniformData = [
    {
        "id": 49,
        "Title": "IES-2024-49",
        "ImageSource": "/Boxing/team uniforms/1.jpg",
        "Category": "Team Uniform"
    },
    {
        "id": 50,
        "Title": "IES-2024-50",
        "ImageSource": "/Boxing/team uniforms/2.jpg",
        "Category": "Team Uniform"
    },
    {
        "id": 51,
        "Title": "IES-2024-51",
        "ImageSource": "/Boxing/team uniforms/3.jpg",
        "Category": "Team Uniform"
    },
    {
        "id": 52,
        "Title": "IES-2024-52",
        "ImageSource": "/Boxing/team uniforms/4.jpg",
        "Category": "Team Uniform"
    },
    {
        "id": 53,
        "Title": "IES-2024-53",
        "ImageSource": "/Boxing/team uniforms/5.jpg",
        "Category": "Team Uniform"
    },
    {
        "id": 54,
        "Title": "IES-2024-54",
        "ImageSource": "/Boxing/team uniforms/6.jpg",
        "Category": "Team Uniform"
    },
    {
        "id": 55,
        "Title": "IES-2024-55",
        "ImageSource": "/Boxing/team uniforms/7.jpg",
        "Category": "Team Uniform"
    },
    {
        "id": 56,
        "Title": "IES-2024-56",
        "ImageSource": "/Boxing/team uniforms/8.jpg",
        "Category": "Team Uniform"
    },
    {
        "id": 57,
        "Title": "IES-2024-57",
        "ImageSource": "/Boxing/team uniforms/9.jpg",
        "Category": "Team Uniform"
    }
];
